import { FC, useMemo } from "react";
import { Product } from "tm-shared/types";

import {
    StyledFacetFilterTagsContainer,
    StyledTag,
} from "./FacetFilterTags.styled";

interface FacetFilterTagsProps {
    products: Record<string, Product>;
    selectedFilters: Record<string, (string | number | boolean)[]>;
    onRemoveFilter: (tag: string, value: string | number | boolean) => void;
}

export const FacetFilterTags: FC<FacetFilterTagsProps> = ({
    products,
    selectedFilters,
    onRemoveFilter,
}) => {
    const tags = useMemo(() => {
        const result: Array<{
            tag: string;
            value: string | number | boolean;
            label: string;
        }> = [];

        const firstProduct = Object.values(products)[0];
        if (!firstProduct) return result;

        Object.entries(selectedFilters).forEach(([tag, values]) => {
            const paramKey = tag as keyof typeof firstProduct.params;

            const paramName =
                firstProduct.params[paramKey]?.paramName || paramKey;

            values.forEach((value) => {
                const displayValue =
                    typeof value === "boolean"
                        ? value
                            ? "Так"
                            : "Ні"
                        : String(value);

                result.push({
                    tag,
                    value,
                    label: `${paramName}: ${displayValue}`,
                });
            });
        });

        return result;
    }, [selectedFilters, products]);

    if (!tags.length) return null;

    return (
        <StyledFacetFilterTagsContainer>
            {tags.map(({ tag, value, label }) => (
                <StyledTag
                    key={`${tag}-${value}`}
                    closable
                    onClose={() => onRemoveFilter(tag, value)}
                >
                    {label}
                </StyledTag>
            ))}
        </StyledFacetFilterTagsContainer>
    );
};
